import EmptyStateReadingPane from '../components/EmptyStateReadingPane';
import { observer } from 'mobx-react-lite';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import LoadingState from 'owa-mail-reading-pane-store/lib/store/schema/LoadingState';
import * as React from 'react';

const styles = require('./ReadingPane.scss');

export interface ItemReadingPaneContentProps {
    loadingState: LoadingState;
    contentCreator: () => JSX.Element;
}

const ItemReadingPaneContent = observer(function ItemReadingPaneContent(
    props: ItemReadingPaneContentProps
) {
    let itemReadingPaneContent: JSX.Element;
    if (!props.loadingState || props.loadingState.isLoading) {
        itemReadingPaneContent = <Spinner className={styles.loadingSpinner} />;
    } else if (props.loadingState.hasLoadFailed) {
        itemReadingPaneContent = <EmptyStateReadingPane isError={true} />;
    } else {
        itemReadingPaneContent = props.contentCreator();
    }

    return itemReadingPaneContent;
});
export default ItemReadingPaneContent;
